import React from 'react';
import FoundryPageShell from './FoundryPageShell';
import ComboKeyTabs, {SanctionsTab} from './ComboKeyTabs';

export default function SanctionsPageShell({active,canManage,children}:{active:SanctionsTab;canManage:boolean;children:React.ReactNode}) {
  return <FoundryPageShell showSidebarOnMobile sidebar={<>
    <p className="text-xs font-black uppercase tracking-[0.18em] text-orange-500">Shipment control</p>
    <h1 className="mt-2 text-2xl font-black text-slate-950 dark:text-white">Sanctielijst</h1>
    <ComboKeyTabs active={active} canManage={canManage}/>
  </>} main={
    <div className="h-full overflow-y-auto p-5 sm:p-8">
      <div className="it-page">
        {children}
      </div>
    </div>
  }/>;
}
